import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 8 10",
  "content": "<symbol viewBox=\"0 0 8 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play\">\n    <path d=\"M7.42652 4.12584C8.11233 4.50685 8.11233 5.49315 7.42652 5.87416L1.48564 9.17464C0.819113 9.54494 0 9.06297 0 8.30049V1.69951C0 0.93703 0.819112 0.455062 1.48564 0.825357L7.42652 4.12584Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol